const getDayByNumber = (num: number, shortly = false) => {
  const days = ['понедельник','вторник','среда','четверг','пятница','суббота','воскресенье'];
  const shortlyDays = ['пн','вт','ср','чт','пт','сб','вс'];
  const responseDay = shortly ? `${shortlyDays[num]}.` : days[num];
  return responseDay[0].toUpperCase() + responseDay.slice(1, responseDay.length);
};

export default getDayByNumber;